(() => {
  if (window.__burdlifeGoogleReviewsLoaded) return;
  window.__burdlifeGoogleReviewsLoaded = true;

  let pendingProductButton = null;

  const showProductHearts = (button) => {
    if (!(button instanceof HTMLElement)) return;
    const item = button.closest('.product__submit__item');
    if (!item) return;

    item.classList.remove('bl-product-love-added');
    void item.offsetWidth;
    item.classList.add('bl-product-love-added');
    window.setTimeout(() => item.classList.remove('bl-product-love-added'), 1800);
  };

  const showProductLove = (button) => {
    if (!(button instanceof HTMLElement)) return;
    const item = button.closest('.product__submit__item');
    const text = button.querySelector('[data-add-to-cart-text]');
    if (!item || !text) return;

    const originalText = text.dataset.blOriginalText || text.textContent.trim();
    text.dataset.blOriginalText = originalText;
    text.textContent = 'Added with love';
    showProductHearts(button);

    window.setTimeout(() => {
      text.textContent = originalText;
    }, 1800);
  };

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest?.('[data-add-to-cart]');
    if (addButton && !addButton.disabled) {
      pendingProductButton = addButton;
      showProductHearts(addButton);
    }

    const nextButton = event.target.closest?.('[data-bl-google-reviews-next]');
    if (!nextButton) return;

    const section = nextButton.closest('[data-bl-google-reviews]');
    const track = section?.querySelector('[data-bl-google-reviews-track]');
    const firstReview = track?.querySelector('.bl-google-reviews__review');
    if (track && firstReview) {
      track.scrollBy({ left: firstReview.getBoundingClientRect().width, behavior: 'smooth' });
    }

    nextButton.classList.remove('is-delighting');
    void nextButton.offsetWidth;
    nextButton.classList.add('is-delighting');
    window.setTimeout(() => nextButton.classList.remove('is-delighting'), 1200);
  });

  document.addEventListener('theme:cart:change', (event) => {
    const eventButton = event.detail?.button;
    const button = eventButton?.matches?.('[data-add-to-cart]') ? eventButton : pendingProductButton;
    showProductLove(button);
    pendingProductButton = null;
  });

  document.addEventListener('theme:product:add', (event) => {
    const eventButton = event.detail?.button;
    const button = eventButton?.matches?.('[data-add-to-cart]') ? eventButton : pendingProductButton;
    showProductLove(button);
    window.setTimeout(() => {
      showProductLove(document.querySelector('[data-add-to-cart]'));
      pendingProductButton = null;
    }, 350);
  });

  document.addEventListener('theme:cart:error', () => {
    pendingProductButton = null;
  });

  const reviewSection = document.querySelector('[data-bl-google-reviews]');
  const reviewTrack = reviewSection?.querySelector('[data-bl-google-reviews-track]');
  if (reviewTrack && window.matchMedia('(max-width: 989px)').matches) {
    window.setInterval(() => {
      if (document.hidden || reviewTrack.matches(':hover, :focus-within')) return;
      const firstReview = reviewTrack.querySelector('.bl-google-reviews__review');
      if (!firstReview) return;
      const maxScroll = reviewTrack.scrollWidth - reviewTrack.clientWidth;
      const nextLeft = reviewTrack.scrollLeft + firstReview.getBoundingClientRect().width;
      reviewTrack.scrollTo({ left: nextLeft >= maxScroll - 4 ? 0 : nextLeft, behavior: 'smooth' });
    }, 5200);
  }

  const cartCount = document.querySelector('[data-cart-count]');
  if (cartCount) {
    let previousCartCount = cartCount.textContent.trim();
    new MutationObserver(() => {
      const nextCartCount = cartCount.textContent.trim();
      if (nextCartCount === previousCartCount) return;
      previousCartCount = nextCartCount;
      if (!pendingProductButton) return;
      showProductLove(pendingProductButton);
      pendingProductButton = null;
    }).observe(cartCount, { childList: true, characterData: true, subtree: true });
  }
})();
